import { Component, OnInit } from '@angular/core';
import { HomeMenu } from 'src/app/models/internal/home-menu';
import { UserPermissions } from 'src/app/permissions';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SummaryForSupplierDTO } from 'src/app/models/summary-for-supplier-dto';
import { BasePage } from '../basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { DataService } from 'src/app/services/data.service';
import { SummaryForPEDTO } from 'src/app/models/summary-for-pe-dto';
import { Menu } from '../constantEnums';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { Constants } from '../constants';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { StorageSettings } from 'src/app/utils/storage.settings';
import Helper from 'src/app/core/utility/helper';

@Component({
    selector: 'tsl-nav',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent extends BasePage implements OnInit {
    homeMenu: HomeMenu[] = [];
    enableLeftMenuScrollFlag: string = "0";
    constructor(
        private authService: AuthService,
        private dataService: DataService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private appGlobalDataService: AppGlobalDataService,
        public storageSettings: StorageSettings) {
        super(localstorageService, logger, appSettings);
        this.appGlobalDataService.IsSupplier.subscribe((data) => {
            if (data &&
                Helper.CheckSupplierLogin(this.storageSettings)) {
                this.getSupplierMenu();
            }
        });

        this.appGlobalDataService.IsEmployee.subscribe((data) => {
            if (data === Constants.IsEmployeeCheckCode &&
                Helper.CheckEmployeeLogin(this.storageSettings)) {
                this.getEmployeeMenu();
            }
        });

        this.appGlobalDataService.loginAs.subscribe((data) => {
            this.setFlags();
            this.refreshMenu();
        });
    }

    ngOnInit() {
        this.refreshMenu();
    }
    private refreshMenu() {
        // TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
        this.appGlobalDataService.IsSupplier.subscribe((data) => {
            if (data && 
                this.IsSupplier &&
                Helper.CheckSupplierLogin(this.storageSettings)) {
                this.getSupplierMenu();
            }
        });

        this.appGlobalDataService.IsEmployee.subscribe((data) => {
            if (data && 
                this.IsEmployee &&
                Helper.CheckEmployeeLogin(this.storageSettings)) {
                this.setFlags();
                if (this.IsLoggedInAsSupplier) {
                    this.getSupplierMenu();
                    // this.getEmployeeMenu();
                } else {
                    this.getEmployeeMenu();
                }
            }
        });

        this.appGlobalDataService.menuSupplierBadges$.subscribe((response) => this.setSupplierBadges(response));
        this.appGlobalDataService.menuEngineerBadges$.subscribe((response) => this.setEngineerBadges(response));
    }
    /**
   * TMS-20796 To scroll contents of left side menu 
   */
     scrollDown(){
        const topcontainer = document.querySelector(".show-scroll-nav-content")
        topcontainer.scrollBy(0, Constants.LEFT_MENU_SCROLL_VERTICAL_PIXELS);
        // console.log('in scrolldown');
    }
    scrollUp(){
        const bottomcontainer = document.querySelector(".show-scroll-nav-content")
        bottomcontainer.scrollBy(0, -Constants.LEFT_MENU_SCROLL_VERTICAL_PIXELS);
        // console.log('in scrollup');
    }
    // Display scroll buttons only if user is PE and flag is enabled from appsettings
    displayScrollButtons(){
        if(!this.IsSupplier && !this.IsLoggedInAsSupplier && !this.isInternalUser()){
            return true;
        }
        return false;
    }
    isInternalUser(){
        if(!this.authService.HasPermission(UserPermissions.Packaging_HotRequests_Read)
        && !this.authService.HasPermission(UserPermissions.Packaging_HotRequests_Write)
        && !this.authService.HasPermission(UserPermissions.Packaging_PackageEngineerAssignment_Read)
        && !this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)
        && !this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Write)){
            return true;
        }
        return false;
    }
    // Obtain value of EnableLeftMenuScroll from services invoked by the backend
    //TMS-30988 Commented as it is not being used currently
    /*  enableLeftMenuScrollFlagSetter() {
        this.dataService
            .getNotificationMessage('EnableLeftMenuScroll')
            .subscribe(
                a => (this.enableLeftMenuScrollFlag = a['Data']['ParameterValue'])
            );
    } */ 
    /**
   * TMS-20796 Based on value fetched from appsettings, set isLeftMenuScrollFlagEnabled to be true only if enableLeftMenuScrollFlag is 1.
   */ 
    isLeftMenuScrollFlagEnabled(){
        if(this.enableLeftMenuScrollFlag == '1'){
            return true;
        }
        return false;
    }
    // Suppliers
    private getSupplierMenu() {
        this.homeMenu = [];
        this.homeMenu.push({
            value: Menu.PendingProposals,
            label: 'Open Actions',
            iconImage: 'av_timer',
            path: '/Pendingproposals'
        });
        // this.homeMenu.push({
        //     value: Menu.PendingProposals,
        //     label: 'Pending Proposals',
        //     iconImage: 'av_timer',
        //     path: '/Pendingproposals'
        // });
        // this.homeMenu.push({
        //     value: Menu.RejectedProposals,
        //     label: 'Rejected Proposals',
        //     iconImage: 'error',
        //     path: '/Rejectedproposals'
        // });
        // TMS-17427 Submitted proposal view for suppliers
        this.homeMenu.push({
            value: Menu.SubmittedProposals,
            label: 'Submitted Proposals',
            iconImage: 'web',
            path: '/Submittedproposals'
        });
        // TMS-17428 Approved page in supplier view
        this.homeMenu.push({
            value: Menu.ApprovedProposals,
            label: 'Approved Proposals',
            iconImage: 'done_all',
            path: '/Approvedproposals',
        });
        // TMS-37630
        // TMS-38739 restore package template view for supplier but read only
        this.homeMenu.push({
            value: Menu.PackageTemplates,
            label: 'Package Templates',
            iconImage: 'web',
            path: '/packageleveltemplateList',
        });
        this.homeMenu.push({
            value: Menu.SearchPart,
            label: 'Search Part',
            iconImage: 'search',
            path: '/searchpart',
        });

       //The supplier summary will be loaded on landing home page. 
       //No need to call supplier's summary call again while loading menu 
       // this.getSummaryForSupplier();
    }

    private getSummaryForSupplier() {
        this.dataService.getSummaryForSupplier().subscribe((response: any) => {
            if (response != null) {
                this.appGlobalDataService.updateMenuSupplierBadges(response.Data);
            }
        });
    }

    private setSupplierBadges(data: SummaryForSupplierDTO) {
        this.homeMenu
            .filter(x => x.value === Menu.PendingProposals)
            .forEach(x => (x.badgeCount = data.OpenAction));
        // this.homeMenu
        //     .filter(x => x.value === Menu.RejectedProposals)
        //     .forEach(x => (x.badgeCount = data.Rejected));        
        this.homeMenu
            .filter(x => x.value === Menu.ApprovedProposals)
            .forEach(x => (x.badgeCount = data.Approved));
        this.homeMenu
            .filter(x => x.value === Menu.SubmittedProposals)
            .forEach(x => (x.badgeCount = data.Submitted));
    }

    // Engineers tms-24755 Commented out function as its no longer being used.
   /* private getSummaryForPE() {
        this.dataService.getSummaryForPE().subscribe((response: any) => {
            if (response != null) {
                this.appGlobalDataService.updateMenuEngineerBadges(response.Data);
            }
        });
    } */

    private setEngineerBadges(data: SummaryForPEDTO) {
        this.homeMenu
            .filter(x => x.value === Menu.ReviewProposals)
            .forEach(x => (x.badgeCount = data.Submitted));
    }

    public getEmployeeMenu() {
        this.homeMenu = [];

        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)) {
            this.homeMenu.push({
                value: Menu.ReviewProposals,
                label: 'Review Proposals',
                iconImage: 'playlist_add_check',
                path: '/Reviewproposals'
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_SearchPart_Read)) {
            this.homeMenu.push({
                value: Menu.SearchPart,
                label: 'Search Part',
                iconImage: 'search',
                path: '/searchpartpe',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)) {
            this.homeMenu.push({
                value: Menu.PendingPhysicalInspection,
                label: 'Pending Inspection',
                iconImage: 'rate_review',
                path: '/PendingInspectionProposals'
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Read)) {
            this.homeMenu.push({
                value: Menu.CreateProposal,
                label: 'Create Proposal',
                iconImage: 'playlist_add',
                path: '/pe-createproposal',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)) {
            this.homeMenu.push({
                value: Menu.AdHocRequest,
                label: 'Ad Hoc Request',
                iconImage: 'playlist_add',
                path: '/AdHocRequest'
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)) {
            this.homeMenu.push({
                value: Menu.CriticalParts,
                label: 'Critical Parts',
                iconImage: 'playlist_add',
                path: '/CriticalParts'
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Read)) {
            this.homeMenu.push({
                value: Menu.ExemptParts,
                label: 'Exempt Parts',
                iconImage: 'search',
                path: '/exemptedpartslist',
            });
        }
        
        if (this.authService.HasPermission(UserPermissions.Packaging_PackageTemplates_Read)) {
            this.homeMenu.push({
                value: Menu.PackageTemplates,
                label: 'Package Templates',
                iconImage: 'web',
                path: '/packageleveltemplateList',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_PackageEngineerAssignment_Read)) {
            this.homeMenu.push({
                value: Menu.ManagePackageEngineers,
                label: 'Package Engineers',
                iconImage: 'people',
                path: '/peassignment',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_SourceType_Read)) {
            this.homeMenu.push({
                value: Menu.SourceType,
                label: 'Add Business Location',
                iconImage: 'playlist_add',
                path: '/addsourcetype',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Write)) {
            this.homeMenu.push({
                value: Menu.BulkUpload,
                label: 'Bulk Upload',
                iconImage: 'playlist_add',
                path: '/bulkupload',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Write)) {
            this.homeMenu.push({
                value: Menu.BulkCopyProposals,
                label: 'Bulk Copy',
                iconImage: 'playlist_add',
                path: '/bulkcopyproposals',
            });
        }


        if (this.authService.HasPermission(UserPermissions.Packaging_ReviewProposal_Write)) {
            this.homeMenu.push({
                value: Menu.AdHocDueDateRequestDashboard,
                label: 'Due Date Extension Requests',
                iconImage: 'web',
                path: '/adhocdueDateRequestDashboard',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Write)) {
            this.homeMenu.push({
                value: Menu.SyncProposals,
                label: 'Sync Proposal Upload',
                iconImage: 'sync',
                path: '/syncproposal',
            });
        }

        if (this.authService.HasPermission(UserPermissions.Packaging_SourceType_Read)) {
            this.homeMenu.push({
                value: Menu.AddPackageEngineer,
                label: 'Add Package Engineer',
                iconImage: 'playlist_add',
                path: '/addpackageengineer',
            });
        }
        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Write)) {
            this.homeMenu.push({
                value: Menu.BulkUploadPackageTemplate,
                label: 'Bulk Upload Package Template',
                iconImage: 'playlist_add',
                path: '/pebulkuploadpackagetemplate',
            });
        } 
        if (this.authService.HasPermission(UserPermissions.Packaging_PackageEngineerAssignment_Write)) {
            this.homeMenu.push({
                value: Menu.AdminInfoButtons,
                label: 'Info Buttons',
                iconImage: 'playlist_add_check',
                path: '/admininfobuttons',
            });
        }
        if (this.authService.HasPermission(UserPermissions.Packaging_PackageEngineerAssignment_Write)) {
            this.homeMenu.push({
                value: Menu.RequestEstimates,
                label: 'Request Package Estimate',
                iconImage: 'playlist_add',
                path: '/bulkuploadestimaterequests',
            });
        }
        if (this.authService.HasPermission(UserPermissions.Packaging_CreateProposal_Write)) {
            this.homeMenu.push({
                value: Menu.Estimates,
                label: 'Upload Package Estimate',
                iconImage: 'playlist_add',
                path: '/bulkuploadestimates',
            });
        }

       //tms-24755 Commented out PE's summary since summary call is re-loaded mutiple times when menu is loaded on landing screen
       // this.getSummaryForPE();
    }
}
